import gql from 'graphql-tag';
import get from 'lodash/get';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';

const QUERY = gql`
  query FacebookAuthState {
    me {
      id

      facebookData {
        authState
      }
    }
  }
`;

export default function queryFacebookAuthState() {
  return apolloClient
    .query({
      query: QUERY,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => getSingleProp(data))
    .then((result) => get(result, 'facebookData.authState'));
}
